
<template>
  <div class="logical-expression-builder">
    <div class="expression-container">
      <!-- Grupos de expressões -->
      <div v-for="(group, groupIndex) in expressionGroups" :key="groupIndex" class="expression-group">
        <div class="conditions-container">
          <div v-if="group.conditions.length === 0" class="empty-group">
            <button @click="openAddConditionModal(groupIndex)" class="add-empty-btn">
              + Adicionar condição
            </button>
          </div>
          <div v-for="(condition, condIndex) in group.conditions" :key="condIndex" class="condition-row">
            <!-- Botão para adicionar nova expressão no grupo (apenas no primeiro item de cada grupo) -->
            <button 
              v-if="condIndex === 0" 
              @click="openAddConditionModal(groupIndex)" 
              class="add-condition-btn" 
              title="Permite adicionar uma nova expressão no grupo"
            >
              +
            </button>
            
            <!-- Condição -->
            <div class="condition">
              <span class="field-text">{{ condition.field }}</span>
              <span class="operator-text">{{ getOperatorDisplay(condition.operator) }}</span>
              <span class="value-text">{{ condition.value }}</span>
              
              <!-- Operador AND entre condições do mesmo grupo com opção de mudar -->
              <span 
                class="operator-toggle" 
                v-if="condIndex < group.conditions.length - 1"
                @click="toggleGroupOperator(groupIndex)"
                title="Permitir editar entre OR / AND"
              >
                {{ group.operator }}
              </span>
            </div>

            <!-- Botão remover para cada condição -->
            <button 
              @click="removeCondition(groupIndex, condIndex)" 
              class="remove-btn"
              title="Remove condição do grupo"
            >
              ✕
            </button>
          </div>
        </div>
        <!-- Botão remover grupo (apenas no último item de cada grupo) -->
        <div 
            v-if="expressionGroups && expressionGroups.length > 1"
            class="flex end"
          >
          <div class="">
            <button 
                @click="removeGroup(groupIndex)" 
                class="remove-group-btn"
                title="Remove grupo"
              >
                <div class="add-group-btn">Remover Grupo</div>
            </button>
          </div>
        </div>
        
        <!-- Operador entre grupos com opção de mudar -->
        <div 
          class="groups-operator-toggle" 
          v-if="groupIndex < expressionGroups.length - 1"
          @click="toggleMainOperator"
          title="Permitir editar entre OR / AND"
        >
          {{ mainOperator }}
        </div>
      </div>
      
      <!-- Botão para adicionar novo grupo -->
      <div class="add-group-container">
        <button 
          @click="addGroup" 
          class="add-group-btn"
          title="Adiciona um novo grupo de regras"
        >
          adicionar novo grupo
        </button>
      </div>
    </div>

    <!-- Modal para adicionar nova condição -->
    <div v-if="showAddConditionModal" class="modal-overlay">
      <div class="modal-content">
        <h3>Adicionar Nova Condição</h3>
        
        <div class="modal-form">
          <div class="">
            <label>Campo:</label>
            <select class="input" v-model="newCondition.field">
              <option v-for="field in availableFields" :key="field.value" :value="field.value">
                {{ field.label }}
              </option>
            </select>
          </div>
          
          <div v-if="newCondition.field !== 'customConversion'" class="">
            <label>Condição:</label>
            <select class="input" v-model="newCondition.operator">
              <option v-for="op in availableOperators" :key="op.value" :value="op.value">
                {{ op.label }}
              </option>
            </select>
          </div>
          
          <div class="">
            <label>Valor:</label>
            <select v-if="newCondition.field === 'customConversion'" class="input" v-model="newCondition.value">
              <option v-for="option in getValuesForField(newCondition.field)" :key="option.value" :value="option.value">
                {{ option.label }}
              </option>
            </select>
            <input v-else class="input" type="text" v-model="newCondition.value">

            <select v-if="false" class="input" v-model="newCondition.value">
              <option v-for="option in getValuesForField(newCondition.field)" :key="option.value" :value="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        
        <div class="modal-actions">
          <button @click="cancelAddCondition" class="cancel-btn">Cancelar</button>
          <button @click="confirmAddCondition" class="confirm-btn">Adicionar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// TODO:
// UTM FLOW
// Permite apenas filtros por UTM em availableFields e fieldValues
// AJUSTEI PARA SEREM ABERTAS SEMPRE

// TODO:
// PAGE FLOW
// Precisamos adicionar um fluxo para permitir URLs ABERTAS
// AJUSTEI PARA SEREM ABERTAS SEMPRE

// TODO:
// CONVERSÕES PERSONALIZADAS FLOW
// Precisamos adicionar um fluxo para permitir CONVERSÕES PERSONALIZADAS
// ÚNICO QUE VAI TER VALORES PRE DEFINIDOS

export default {
  name: 'LogicalExpressionBuilder',
  props: {
    initialOptions: {
      type: Array,
      default: () => []
    },
    initialConditions: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      // Operador principal entre grupos
      mainOperator: 'OR',
      
      // Modal para adicionar condição
      showAddConditionModal: false,
      activeGroupIndex: null,
      newCondition: {
        fieldType: '',
        field: '',
        operator: 'equals',
        value: ''
      },
      
      // Campos disponíveis para seleção
      availableFields: [
        { value: 'url', label: 'Url' },
        { value: 'customConversion', label: 'Conversão Personalizada' },
        { value: 'sale', label: 'Venda' },
        { value: 'lead', label: 'Lead' },
        { value: 'message', label: 'Mensagem' },
        // { value: 'product', label: 'Produto' },
        { value: '', label: '' },
        { value: 'utm_source', label: 'utm_source' },
        { value: 'utm_content', label: 'utm_content' },
        { value: 'utm_medium', label: 'utm_medium' },
        { value: 'utm_campaign', label: 'utm_campaign' },
        { value: 'utm_term', label: 'utm_term' },
        { value: 'src', label: 'src' },
        { value: 'sck', label: 'sck' },
      ],

      
      // Operadores disponíveis
      availableOperators: [
        { value: 'equals', label: 'Igual' },
        { value: 'contains', label: 'Contém' },
        { value: 'not_contains', label: 'Não Contém' },
        { value: 'not_equals', label: 'Diferente' }
      ],
      
      // Valores disponíveis para cada campo
      fieldValues: {
        url: [
          { value: 'www.teste.com', label: 'www.teste.com' },
        ],
        customConversion: [
          { value: 'INTEGRACAO FACEBOOK', label: 'INTEGRACAO FACEBOOK' },
        ],
        utm_source: [
          { value: 'FACEBOOK', label: 'FACEBOOK' },
          { value: 'INSTAGRAM', label: 'INSTAGRAM' },
          { value: 'GOOGLE', label: 'GOOGLE' },
          { value: 'LINKEDIN', label: 'LINKEDIN' }
        ],
        utm_content: [
          { value: 'AD01', label: 'AD01' },
          { value: 'AD02', label: 'AD02' },
          { value: 'AD03', label: 'AD03' },
          { value: 'AD04', label: 'AD04' },
          { value: 'AD05', label: 'AD05' }
        ],
        utm_medium: [
          { value: 'CPC', label: 'CPC' },
          { value: 'EMAIL', label: 'EMAIL' },
          { value: 'SOCIAL', label: 'SOCIAL' }
        ],
        utm_campaign: [
          { value: 'PROMO_2023', label: 'PROMO_2023' },
          { value: 'BLACK_FRIDAY', label: 'BLACK_FRIDAY' },
          { value: 'LAUNCH', label: 'LAUNCH' }
        ],
        utm_term: [
          { value: 'TERM1', label: 'TERM1' },
          { value: 'TERM2', label: 'TERM2' },
          { value: 'TERM3', label: 'TERM3' }
        ],
        src: [
          { value: 'FACEBOOK', label: 'FACEBOOK' },
          { value: 'INSTAGRAM', label: 'INSTAGRAM' },
          { value: 'GOOGLE', label: 'GOOGLE' },
          { value: 'LINKEDIN', label: 'LINKEDIN' }
        ],
        sck: [
          { value: 'FACEBOOK', label: 'FACEBOOK' },
          { value: 'INSTAGRAM', label: 'INSTAGRAM' },
          { value: 'GOOGLE', label: 'GOOGLE' },
          { value: 'LINKEDIN', label: 'LINKEDIN' }
        ],
      },
      
      // Grupos de expressões
      expressionGroups: [{
        operator: 'AND',
        conditions: []
        },
      ]
    };
  },
  mounted() {

    if (this.initialConditions && this.initialConditions.length > 0) {
      this.expressionGroups = this.initialConditions
    }
    // Inicializa exemplos conforme a imagem
    // this.expressionGroups = [
    //   {
    //     operator: 'AND',
    //     conditions: [
    //       { field: 'utm_source', operator: 'equals', value: 'FACEBOOK' },
    //       { field: 'utm_content', operator: 'equals', value: 'AD01' }
    //     ]
    //   },
    //   {
    //     operator: 'AND',
    //     conditions: [
    //       { field: 'utm_source', operator: 'equals', value: 'INSTAGRAM' },
    //       { field: 'utm_content', operator: 'equals', value: 'AD05' }
    //     ]
    //   }
    // ];
  },
  watch: {
    expressionGroups: {
      deep: true,
      handler() {
        this.saveExpression()

      },
    }
  },
  methods: {
    // Retorna a representação visual do operador
    getOperatorDisplay(operator) {
      switch(operator) {
        case 'equals': return '=';
        case 'not_equals': return '≠';
        case 'contains': return 'contém';
        case 'not_contains': return 'não contém';
        default: return '=';
      }
    },
    
    // Retorna os valores disponíveis para um campo específico
    getValuesForField(field) {
      return this.fieldValues[field] || [];
    },
    
    // Abre o modal para adicionar nova condição
    openAddConditionModal(groupIndex) {
      this.activeGroupIndex = groupIndex;
      this.newCondition = {
        field: this.availableFields[0].value,
        operator: 'equals',
        value: ''
        // value: this.fieldValues[this.availableFields[0].value][0].value
      };
      this.showAddConditionModal = true;
    },
    
    // Cancela a adição de condição
    cancelAddCondition() {
      this.showAddConditionModal = false;
      this.activeGroupIndex = null;
    },
    
    // Confirma a adição de condição
    confirmAddCondition() {
      if (this.activeGroupIndex !== null) {
        this.expressionGroups[this.activeGroupIndex].conditions.push({
          field: this.newCondition.field,
          operator: this.newCondition.operator,
          value: this.newCondition.value
        });
      }
      this.showAddConditionModal = false;
      this.activeGroupIndex = null;
    },
    
    // Alterna o operador dentro de um grupo (AND/OR)
    toggleGroupOperator(groupIndex) {
      const group = this.expressionGroups[groupIndex];
      group.operator = group.operator === 'AND' ? 'OR' : 'AND';
    },
    
    // Alterna o operador principal entre grupos (AND/OR)
    toggleMainOperator() {
      this.mainOperator = this.mainOperator === 'OR' ? 'AND' : 'OR';
    },
    
    // Adiciona um novo grupo de condições (vazio)
    addGroup() {
      this.expressionGroups.push({
        operator: 'AND',
        conditions: []
      });
    },
    
    // Remove um grupo de condições
    removeGroup(groupIndex) {
      if (this.expressionGroups.length > 1) {
        this.expressionGroups.splice(groupIndex, 1);
      } else {
        // Se for o último grupo, mantém pelo menos um grupo vazio
        this.expressionGroups = [{
          operator: 'AND',
          conditions: []
        }];
      }
    },
    
    // Remove uma condição de um grupo
    removeCondition(groupIndex, conditionIndex) {
      const group = this.expressionGroups[groupIndex];
      
      // Remove a condição
      group.conditions.splice(conditionIndex, 1);
      
      // Se o grupo ficou vazio, não faz nada especial - mantém o grupo vazio
    },
    
    // Gera o JSON com as expressões lógicas
    generateJson() {
      // Filtra grupos vazios
      const nonEmptyGroups = this.expressionGroups.filter(group => group.conditions.length > 0);
      
      // Se não houver condições
      if (nonEmptyGroups.length === 0) {
        return null;
      }
      
      // Se houver apenas um grupo com uma condição
      if (nonEmptyGroups.length === 1 && nonEmptyGroups[0].conditions.length === 1) {
        const condition = nonEmptyGroups[0].conditions[0];
        return {
          type: 'condition',
          field: condition.field,
          operator: condition.operator,
          value: condition.value
        };
      }
      
      // Para expressões mais complexas
      const result = {
        type: 'expression',
        operator: this.mainOperator,
        conditions: []
      };
      
      nonEmptyGroups.forEach(group => {
        if (group.conditions.length === 1) {
          // Uma única condição no grupo
          result.conditions.push({
            type: 'condition',
            field: group.conditions[0].field,
            operator: group.conditions[0].operator,
            value: group.conditions[0].value
          });
        } else {
          // Múltiplas condições no grupo
          const groupCondition = {
            type: 'group',
            operator: group.operator,
            conditions: group.conditions.map(c => ({
              type: 'condition',
              field: c.field,
              operator: c.operator,
              value: c.value
            }))
          };
          result.conditions.push(groupCondition);
        }
      });
      
      return result;
    },
    
    // Método para exportar a expressão
    saveExpression() {
      // const result = this.generateJson();
      const result = this.expressionGroups;
      this.$emit('save', result)
      // return result;
    }
  }
};
</script>

<style lang="scss" scoped>
.logical-expression-builder {
  font-family: Arial, sans-serif;
  color: var(--text);;
  background-color: var(--bg);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  margin: 0 auto;
}

.expression-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.expression-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}


.condition-row {
  display: flex;
  align-items: center;
  position: relative;
  background-color: var(--bg);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 15px 20px;
}

.empty-group {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bg);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 25px 20px;
  position: relative;
}

.add-empty-btn {
  background-color: transparent;
  color: var(--text);;
  border: 1px solid var(--text);;
  border-radius: 20px;
  padding: 8px 15px;
  font-size: 14px;
  cursor: pointer;
}

.add-empty-btn:hover {
  background-color: var(--primary);
  color: #fff;
  color: #fff;
}

.condition {
  display: flex;
  align-items: center;
  flex-grow: 1;
  font-size: 16px;
}

.field-text, .value-text {
  font-family: monospace;
  padding: 5px;
}

.operator-text {
  margin: 0 5px;
  font-family: monospace;
}

.operator-toggle {
  margin: 0 10px;
  font-weight: bold;
  font-family: monospace;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 4px;
}

.operator-toggle:hover {
  background-color: var(--text);
}

.groups-operator-toggle {
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
  font-size: 16px;
  font-family: monospace;
  cursor: pointer;
}

.groups-operator-toggle:hover {
  text-decoration: underline;
}

.remove-btn {
  background: transparent;
  color: var(--text);;
  border: none;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  margin-left: 5px;
}

.remove-group-btn {
  background: transparent;
  color: var(--text);;
  border: none;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  height: 30px;
  padding: 0;
  margin-left: 5px;
}


.remove-btn:hover, .remove-group-btn:hover {
  color: #ff6b6b;
}

.remove-group-btn {
  position: relative;
  margin-top: 8px;
}

.add-condition-btn {
  background: transparent;
  color: var(--text);;
  border: 1px solid var(--text);;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  margin-right: 10px;
}

.add-condition-btn:hover {
  background-color: var(--text);
}

.add-group-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.add-group-btn {
  background-color: transparent;
  color: var(--text);;
  border: 1px solid var(--text);;
  border-radius: 20px;
  padding: 8px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-group-btn:hover {
  background-color:var(--text);
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--boxbg);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 20px;
  width: 600px;
  max-width: 90%;
}

.modal-content h3 {
  margin-top: 0;
  color: var(--text);;
  text-align: center;
  margin-bottom: 20px;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  select {
    cursor: pointer;
  }
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn, .confirm-btn {
  padding: 8px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.cancel-btn {
  background-color: transparent;
  color: var(--text);
  border: 1px solid #444;
}

.confirm-btn {
  background-color: var(--primary);
  color: #fff;
  color: #fff;
  border: none;
}

.confirm-btn:hover {
  background-color: var(--primary);
  color: #fff;
}
</style><!-- LogicalExpressionBuilder.vue -->

<style scoped>
.logical-expression-builder {
  font-family: Arial, sans-serif;
  color: var(--text);
  background-color: var(--boxbg);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  margin: 0 auto;
}

.expression-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.expression-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.conditions-container {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 10px;
  border: 1px solid var(--border);
  padding: 8px;
  border-radius: 15px;
}

.condition-row {
  display: flex;
  align-items: center;
  position: relative;
  background-color: var(--bg);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 15px 20px;
}

.condition {
  display: flex;
  align-items: center;
  flex-grow: 1;
  font-size: 16px;
}

select {
  background-color: transparent;
  color: var(--text);
  border: none;
  font-size: 16px;
  font-family: monospace;
  padding: 5px;
  margin: 0 5px;
  appearance: none; /* Remove default arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
}

select:focus {
  outline: none;
}

.operator-text {
  margin: 0 5px;
  font-family: monospace;
}

.operator-toggle {
  margin: 0 10px;
  font-weight: bold;
  font-family: monospace;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 4px;
}

.operator-toggle:hover {
  background-color: var(--primary);
  color: #fff;
}

.groups-operator-toggle {
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
  font-size: 16px;
  font-family: monospace;
  cursor: pointer;
}

.groups-operator-toggle:hover {
  text-decoration: underline;
}

.remove-btn:hover, .remove-group-btn:hover {
  color: #ff6b6b;
}

.add-condition-btn {
  background: transparent;
  color: var(--text);
  border: 1px solid var(--text);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  margin-right: 10px;
}

.add-condition-btn:hover {
  background-color: var(--primary);
  color: #fff;

}

.add-group-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.add-group-btn {
  background-color: transparent;
  color: var(--text);
  border: 1px solid var(--text);
  border-radius: 20px;
  padding: 8px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-group-btn:hover {
  background-color: var(--primary);
  color: #fff;
}
</style>